import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Box, MenuItem
} from "@mui/material";

const CommonEditDialog = ({ open, onClose, onSave, title, fields, initialData = {}, formatter }) => {
  const [formState, setFormState] = useState({});

  useEffect(() => {
    if (open) {
      setFormState(initialData);
    }
  }, [open, initialData]);

  const handleChange = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveClick = () => {
    const finalData = formatter ? formatter(formState) : formState;
    onSave(finalData);
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          {fields.map(({ label, field, multiline, rows, select, options }) => (
            <TextField
              key={field}
              label={label}
              value={formState[field] || ""}
              onChange={(e) => handleChange(field, e.target.value)}
              multiline={multiline}
              rows={rows}
              select={select}
              fullWidth
            >
              {select &&
                options?.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
            </TextField>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          onClick={handleSaveClick}
          variant="contained"
          color="primary"
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommonEditDialog;
